import { validateZipcode } from '@/lib/validation/zipcodeValidation';
import z from 'zod';

export const addressSchema = z
  .object({
    country: z.string().min(1, 'Country is required'),
    city: z.string().min(1, 'City is required'),
    line1: z.string().min(1, 'Address line is required'),
    line2: z.string().optional(),
    zipcode: z.string().min(1, 'Zip code is required'),
  })
  .refine((data) => validateZipcode(data.zipcode, data.country), {
    message: 'Invalid zipcode for the selected country',
    path: ['zipcode'],
  });

export const createAddressSchema = addressSchema;

export const updateAddressSchema = z.object({
  ...addressSchema.shape,
  name: z.string().min(1, 'Name is required'),
});
